import React, { useEffect } from 'react';
import { SEO } from 'src/components/SEO';
import Footer from 'src/components/footer';
import { ProductFeaturesWithCta } from 'src/components/products/productFeaturesWithCta';
import { pageSeoInfo } from 'src/constants/seo';
import { PrimaryHero } from 'src/modules/PrimaryHero';
import { FeaturedProduct } from 'src/modules/featuredProduct';
import { HeroModule } from 'src/modules/heroModule';
import { InstagramModule } from 'src/modules/Instagram/instagramModule';
import { ShopFood } from 'src/modules/shopFood';
import { TestimonialCarousel } from 'src/modules/testimonialCarousel/testimonialCarousel';
import { Link, navigate } from 'gatsby';

interface Props {
  pageContext: {
    menus: [];
    footer: Record<string, unknown>;
    homePageModules: Record<string, Array<any>>;
  };
}

const IndexPage = ({ pageContext }: Props) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      console.log('url from src/pages', window.location.href);

      if (window.location.href.includes('support.catperson.com')) {
        navigate('https://help.weruva.com');
        return;
      } else {
        navigate('https://www.weruva.com/collections/cat-person');
      }
    }
  }, []);
};

export default IndexPage;

export const Head = ({ location }) => {
  const metaInfo = pageSeoInfo('home');
  return metaInfo && <SEO metaInfo={metaInfo} pagePath={location.pathname} />;
};
